import { FullPageSpinner } from "@resamare/ui";
import { PropsWithChildren, useEffect } from "react";
import { AuthStatus, useAuth } from "../providers/AuthProvider";

export function AuthLoader({ children }: PropsWithChildren) {
    const { authStatus, authenticate } = useAuth();

    useEffect(() => {
        authenticate();
    }, []);

    if (authStatus === AuthStatus.UNKNOWN) {
        return <FullPageSpinner />;
    }

    return children;
}
